import { useState } from 'react';
import { LibraryItem } from './hooks/useLibrary';
import { cn } from '@/src/lib/utils';
import moment from 'moment-timezone';
import AssetPreview, { assetKind } from './AssetPreview';

// Removed styled ImagePreview - now using DeviceAwareImage component

export default function LibraryLists({
    files,
    onImageSelected,
}: {
    files: LibraryItem[];
    onImageSelected: (image: string) => void;
}) {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    return (
        <div className="relative">
            <ul className="flex flex-col gap-y-1 max-h-[75vh] overflow-y-auto py-2 z-1">
                {files.map((file, index) => (
                    <li
                        key={file.url}
                        className={cn('relative')}
                        onClick={(e) => {
                            e.stopPropagation();

                            if (selectedIndex === index) {
                                setSelectedIndex(null);
                                onImageSelected('');
                            } else {
                                setSelectedIndex(index);
                                onImageSelected(file.url);
                            }
                        }}
                    >
                        <ImageRow
                            file={file}
                            selected={selectedIndex === index}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
}

function ImageRow({
    file,
    selected,
}: {
    file: LibraryItem;
    selected: boolean;
}) {
    return (
        <div
            className={cn(
                'rounded-sm flex flex-row gap-x-2 cursor-pointer justify-between px-2 py-1 items-center bg-[#F4F4F1] dark:bg-[#262C2C] border-1 border-black/10 dark:border-white/10',
                selected && 'bg-[#000000]/50 dark:bg-[#ffffff]/50',
            )}
        >
            <div className="flex flex-row gap-x-2 w-[400px] items-center">
                <div
                    className={cn(
                        'group relative overflow-hidden h-[50px] w-[50px] flex justify-center items-center',
                    )}
                >
                    <AssetPreview asset={file} compact />
                </div>
                <div className="text-sm text-[#333333] dark:text-[#F4F4F1] px-2 justify-center">
                    <div className="flex flex-row justify-start items-center">
                        {file.name}
                    </div>
                </div>
            </div>

            <div className="flex flex-row justify-center items-center w-[200px]">
                <span className="text-xs uppercase">{assetKind(file)}</span>
            </div>
            <div className="flex flex-row justify-start items-center w-[100px] hidden md:block">
                <div className="text-sm text-[#333333] dark:text-[#F4F4F1] px-2">
                    {moment(file.createdAt).format('MM/DD/YYYY')}
                </div>
            </div>
        </div>
    );
}
